import React, { FC } from 'react'
import checkmark from '@mortgage-pos/ui/assets/Checkmark.svg'
import { cashOutCheckListContent } from '../data/cashOutCheckListContent'
import { useStoreState } from 'easy-peasy'

export const ListContent = () => {
  const { mergedAnswers } = useStoreState((state) => state.answers)
  const { refiReason } = mergedAnswers
  return (
    <div>
      {cashOutCheckListContent.map((content) => {
        if (content.name === refiReason) {
          return (
            <div className="list-content__wrapper" key={content.name}>
              <div
                className="list-content__title"
                data-testid="list-content__title"
              >
                {content.title}
              </div>
              {content.options.map((option) => {
                return (
                  <div
                    key={option.text}
                    data-testid="list-content__option"
                    className="list-content__option"
                  >
                    <div className="list-content__option-checkmark-wrapper">
                      <img
                        className={'list-content__option-checkmark'}
                        src={checkmark}
                        alt="checkmark icon"
                      />
                    </div>
                    <span
                      data-testid="list-content__option-text"
                      className="list-content__option-text"
                    >
                      {option.text}
                    </span>
                  </div>
                )
              })}
            </div>
          )
        }
      })}
    </div>
  )
}
